// Module
var code = "<div class=\"curtain-notifications alert\"> <span class=curtain-notification-message ng-bind-html=\"curtainNotifications.getMessage() | translate:curtainNotifications.getInterpolateParams()\"></span> <button type=button class=\"clean-button close\" ng-click=close()>&times;</button> </div>";
// Exports
module.exports = code;